import { useQuery } from '@tanstack/react-query';

import {
  getAllFeaturesWithPricing,
  getPlanByStripePriceId,
  getPricingCardByPriceId,
  getPricingCardsForFeature,
  getPricingCardsForPlan,
} from '@/actions/pricing';

import { queryKeys } from '@/constants/query-keys';

export function usePricingCards(featureName: string) {
  return useQuery({
    queryKey: [queryKeys.pricing, featureName],
    queryFn: async () => {
      const result = await getPricingCardsForFeature(featureName);
      if (result.error) {
        throw result.error;
      }
      return result.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export function useAllFeaturesWithPricing() {
  return useQuery({
    queryKey: [queryKeys.pricing, 'features'],
    queryFn: async () => {
      const result = await getAllFeaturesWithPricing();
      if (result.error) {
        throw result.error;
      }
      return result.data;
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
}

export function usePricingCardsForPlan(planNames: string[]) {
  return useQuery({
    queryKey: [queryKeys.pricing, 'plans', planNames],
    queryFn: async () => {
      const result = await getPricingCardsForPlan(planNames);
      if (result.error) {
        throw result.error;
      }
      return result.data;
    },
    enabled: planNames.length > 0,
  });
}

export function usePricingCardByPriceId(priceId: string) {
  return useQuery({
    queryKey: [queryKeys.pricing, 'card', priceId],
    queryFn: async () => {
      const result = await getPricingCardByPriceId(priceId);
      if (result.error) {
        throw result.error;
      }
      return result.data;
    },
    enabled: !!priceId,
  });
}

export function usePlanByStripePriceId(priceId: string) {
  return useQuery({
    queryKey: [queryKeys.pricing, 'card', priceId],
    queryFn: async () => {
      const result = await getPlanByStripePriceId(priceId);
      if (result.error) {
        throw result.error;
      }
      return result.data;
    },
    enabled: !!priceId,
  });
}
